import React, {useEffect, useState} from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import {Container} from './CartoonitoGamesGrid.styles';

import ContentBox from '../ContentBox';
import {useBreakpoint} from '../../styles';

function CartoonitoGamesGrid({
    items,
    featured,
    hidePlayButton,
    onClickItem,
    infinite,
    previewAmount,
}) {
    const [minWidth, setMinWidth] = useState(undefined);

    useEffect(() => {
        handleWindowResize({target: window});

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, [items]);

    const handleWindowResize = evt => {
        const cardMobileWidth = Math.min(0.2068 * evt.target?.innerWidth, 168);
        const mobileRowCount = 2;
        const gridMargin = 42;
        const gridGap = 18;
        const featuredCardWidth = Math.min(
            0.4384 * evt.target?.innerWidth,
            356,
        );
        const gridMinWidth =
            ((items?.length - 1) / mobileRowCount) *
                (cardMobileWidth + gridGap) +
            gridMargin * 2 +
            featuredCardWidth;

        setMinWidth(gridMinWidth);
    };

    const renderContainer = () => (
        <Container id="games-grid" minWidth={minWidth}>
            {items.map((item, index) => {
                return (
                    <ContentBox
                        key={item.id}
                        id={item.id}
                        data={item}
                        featured={featured}
                        hideFavouriteButton
                        hidePlayButton={hidePlayButton}
                        background={item.image}
                        title={item.showName}
                        sub={item.title}
                        type="game"
                        action={() => onClickItem(item.id, item)}
                        cnito
                    />
                );
            })}
        </Container>
    );

    return ['xs', 'mobile', 'sm'].includes(useBreakpoint()) ? (
        <ScrollContainer>{renderContainer()}</ScrollContainer>
    ) : (
        renderContainer()
    );
}

export default CartoonitoGamesGrid;
